export enum PlatformLookup {
    MT4L = 'MT4-L',
    MT4D = 'MT4-D',
    MT5L = 'MT5-L',
    MT5D = 'MT5-D',
    MT4ROWL = 'MT4-ROW-L',
    MT4ROWD = 'MT4-ROW-D',
    MT4_ROW2_D = 'MT4-ROW2-D',
    MT4_ROW2_L = 'MT4-ROW2-L',
    MT4CN2L = 'MT4-CN2-L',
    //Focus markets
    MT5L_FCS = 'MT5-FCS-L',
    MT5D_FCS = 'MT5-FCS-D',
    //Blueberry
    MT4_BBL = 'MT4-BB-L',
    MT4_BBD = 'MT4-BB-D',
    MT5_BBL = 'MT5-BB-L',
    MT5_BBD = 'MT5-BB-D',
    TV = 'TV'
}
